import React from 'react';
import {
	HStack,
	Text,
	IconSignOut,
} from '@montel/montelpro-shared-components-v2';
import { StyledProfileMenuItem } from '../styles';
import { useAuth } from '@montel/montelpro-auth';

const SignOutButton = () => {
	const { authRoutes } = useAuth();

	return (
		<StyledProfileMenuItem>
			<a href={authRoutes.logout}>
				<HStack fullWidth align="center" justify="space-between">
					<Text size="xs">Sign out</Text>
					<IconSignOut color="white" />
				</HStack>
			</a>
		</StyledProfileMenuItem>
	);
};
export default SignOutButton;
